<script lang="ts">
  import TextArea from '$components/reusable/TextArea.svelte';
  import TextInput from '$components/reusable/TextInput.svelte';
  import Checkbox from '$components/reusable/checkbox/Checkbox.svelte';
  import DropdownInput from '$components/reusable/dropdowns/DropdownInput.svelte';
  import AvatarInput from '$components/reusable/images/AvatarInput.svelte';
  import { COUNTRIES, LANGUAGES } from '$utils/constants';
  import UsernameInput from '$components/reusable/UsernameInput.svelte';
  import type { Infer, SuperForm } from 'sveltekit-superforms/client';
  import type { editProfileSchema } from '$shared/lib';

  export let avatarUrl: string;
  export let showImageEditing: boolean;
  export let superform: SuperForm<Infer<typeof editProfileSchema>>;
  const { form, errors, enhance, constraints } = superform;
</script>

<form method="POST" use:enhance class="space-y-2xl p-[3px]">
  <AvatarInput
    bind:avatarUrl
    bind:avatarId={$form.avatarId}
    bind:showImageEditing
    isFullSize={false}
  />
  <div class="gap-x-lg flex items-start">
    <TextInput
      label="Display name"
      placeholder="Anatoly Yakovenko"
      bind:value={$form.displayName}
      bind:errors={$errors.displayName}
      {...$constraints.displayName}
    />
    <UsernameInput
      placeholder="toly"
      bind:value={$form.username}
      bind:errors={$errors.username}
      {...$constraints.username}
    />
  </div>
  <TextInput
    label="Headline"
    description="A description of your current professional role or what you are looking for."
    placeholder="Co-founder @ Solana"
    bind:value={$form.headline}
    bind:errors={$errors.headline}
    bind:constraints={$constraints.headline}
  />
  <div class="gap-x-lg flex items-start">
    <DropdownInput
      label="Country"
      items={COUNTRIES}
      bind:selectedValue={$form.country}
      bind:errors={$errors.country}
      {...$constraints.country}
    />
    <TextInput label="City" bind:value={$form.city} bind:errors={$errors.city} />
  </div>
  <DropdownInput
    label="Languages Spoken"
    items={Object.values(LANGUAGES).flatMap((language) => language.name)}
    multiple
    bind:selectedValues={$form.languages}
    bind:errors={$errors.languages}
    bind:constraints={$constraints.languages}
  />
  <TextArea label="About You" bind:value={$form.about} bind:errors={$errors.about} />
  <Checkbox label="Currently a university student" bind:checked={$form.isUniversityStudent} />
</form>
